import { LANGUAGES } from 'consts';
import { LanguageKeyType } from 'types';

export const getNavigatorLanguage = (): LanguageKeyType | undefined =>
  LANGUAGES.find(langKey => window.navigator.language.startsWith(langKey));
